import React from 'react'

const SearchSvg = () => (
  <svg width="8" height="16" viewBox="0 0 8 16">
    <path d="M0 .3L7.7 8 0 15.7z" />
  </svg>
)

export default SearchSvg
